import { render, staticRenderFns } from "./SkeletonSimpleCard.vue?vue&type=template&id=125d8da3&"
import script from "./SkeletonSimpleCard.vue?vue&type=script&lang=js&"
export * from "./SkeletonSimpleCard.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonSimpleCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports